import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";

export const DeletePropertiesResponseSchema = BaseResponseSchema.extend({
    data: z.null()
});

export type DeletePropertiesResponse = z.infer<typeof DeletePropertiesResponseSchema>;
